import { apiGet, apiPost, apiPut, apiDelete, planningPath } from './PlanningApiClient';
import { uploadImage } from './uploadService';

export interface FloorPlan {
  id: string;
  project_id: string;
  /** Older servers only send this spelling. */
  wedding_id?: string;
  venue_id: string;
  name: string;
  scale?: number;
  width?: number;
  height?: number;
  image_url?: string | null;
  sort_order?: number;
  created_at?: string;
  updated_at?: string;
}

export async function getFloorPlans(venueId?: string): Promise<FloorPlan[]> {
  const suffix = venueId != null ? `/floor-plans?venue_id=${encodeURIComponent(venueId)}` : '/floor-plans';
  const data = await apiGet<{ floor_plans: FloorPlan[] }>(planningPath(suffix));
  return data.floor_plans || [];
}

export async function createFloorPlan(name: string, venueId: string, imageFile?: File | null): Promise<FloorPlan> {
  const fp = await apiPost<FloorPlan>(planningPath('/floor-plans'), { name, venue_id: venueId });
  if (imageFile) {
    try {
      const attachment = await uploadImage(imageFile, { entityType: 'floor_plan', entityId: String(fp.id) });
      return apiPut<FloorPlan>(planningPath(`/floor-plans/${fp.id}`), { image_url: attachment.url });
    } catch {
      // image upload failed — return the floor plan without image
    }
  }
  return fp;
}

export async function deleteFloorPlan(id: string): Promise<void> {
  await apiDelete(planningPath(`/floor-plans/${id}`));
}

export async function updateFloorPlanImage(id: string, imageFile: File): Promise<FloorPlan> {
  const attachment = await uploadImage(imageFile, { entityType: 'floor_plan', entityId: String(id) });
  return apiPut<FloorPlan>(planningPath(`/floor-plans/${id}`), { image_url: attachment.url });
}
